import { dateOperators, textOperators } from '../../../utils/constants/operators'
import { Checkbox, FormControlLabel } from '@mui/material'
import React from 'react'

const AccessCheckbox = ({ label, field, props, onRowDataChange, getModuleRight }) => (
  <FormControlLabel
    control={
      <Checkbox
        checked={props[field] || false}
        onChange={(e) => onRowDataChange({ ...props, [field]: e.target.checked })}
        disabled={!getModuleRight(props.module_id, field)}
      />
    }
    label={label}
  />
)

export const getRoleColumns = () => [
  {
    name: 'name',
    label: 'Rôle',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'createdDateTime',
    label: 'Date Création',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'createdBy',
    label: 'Créé Par',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'lastModDateTime',
    label: 'Date Modification',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'lastModBy',
    label: 'Modifié Par',
    isFilter: true,
    operators: textOperators
  }
]

export const getRoleFields = (user, role, modulesList, setAccessRights) => {
  const safeModulesList = Array.isArray(modulesList) ? modulesList : []

  const getModuleRight = (moduleId, right) => safeModulesList.find((m) => m.id === moduleId)?.[right] ?? false

  return [
    [
      {
        name: 'name',
        label: 'Rôle',
        required: true,
        type: 'text',
        fullWidth: true,
        validation: [{ rule: 'req', error: 'Rôle obligatoire' }]
      }
    ],
    [
      {
        name: 'is_admin',
        label: 'Administrateur',
        type: 'checkbox',
        readOnlyWhen: () => (user.role.is_admin && user.role.is_grant_admin) || false,
        fullWidth: true
      }
    ],
    [
      {
        name: 'is_grant_admin',
        label: 'Accorder le droit administrateur',
        readOnlyWhen: () => user.role.is_grant_admin || false,
        type: 'checkbox',
        fullWidth: true
      }
    ],
    [
      {
        name: 'access_rights',
        label: 'Lignes',
        type: 'mytable',
        tableOptions: {
          paperStyle: { width: '100%', margin: '0 auto' },
          setDataParent: setAccessRights,
          columns: [
            {
              name: 'module_id',
              label: 'Module',
              type: 'listSelect',
              mapping: (value) => {
                const module = safeModulesList.find((m) => m.id === value)
                return module ? module.module : value
              },
              onChangeF: (row, modules, onRowDataChange) => {
                const safeModules = Array.isArray(modules) ? modules : []
                const module = safeModules.find((m) => m.id === row.module_id)
                const updated = {
                  ...row,
                  is_quantity: module?.is_quantity ?? false,
                  module_id: module?.id ?? row.module_id,
                  is_access: row.is_access
                }
                onRowDataChange(updated)
              },
              optionsAPI: {
                api: 'modules',
                filter: () => ({})
              },
              dataId: () => 'module_id',
              optionLabel: 'module',
              returnField: 'id',
              enableEditing: false,
              validation: [{ rule: 'req', error: 'Module obligatoire' }]
            },
            {
              label: 'Accès',
              name: 'is_access',
              type: 'checkbox',
              render: (props, onRowDataChange) => (
                <AccessCheckbox
                  field='is_access'
                  props={props}
                  onRowDataChange={onRowDataChange}
                  getModuleRight={getModuleRight}
                />
              )
            },
            {
              label: 'Liste',
              name: 'is_list',
              type: 'checkbox',
              render: (props, onRowDataChange) => (
                <AccessCheckbox
                  field='is_list'
                  props={props}
                  onRowDataChange={onRowDataChange}
                  getModuleRight={getModuleRight}
                />
              )
            },
            {
              label: 'Afficher',
              name: 'is_view',
              type: 'checkbox',
              render: (props, onRowDataChange) => (
                <AccessCheckbox
                  field='is_view'
                  props={props}
                  onRowDataChange={onRowDataChange}
                  getModuleRight={getModuleRight}
                />
              )
            },
            {
              label: 'Modifier',
              name: 'is_edit',
              type: 'checkbox',
              render: (props, onRowDataChange) => (
                <AccessCheckbox
                  field='is_edit'
                  props={props}
                  onRowDataChange={onRowDataChange}
                  getModuleRight={getModuleRight}
                />
              )
            },
            {
              label: 'Ajouter',
              name: 'is_add',
              type: 'checkbox',
              render: (props, onRowDataChange) => (
                <AccessCheckbox
                  field='is_add'
                  props={props}
                  onRowDataChange={onRowDataChange}
                  getModuleRight={getModuleRight}
                />
              )
            },
            {
              label: 'Supprimer',
              name: 'is_delete',
              type: 'checkbox',
              render: (props, onRowDataChange) => (
                <AccessCheckbox
                  field='is_delete'
                  props={props}
                  onRowDataChange={onRowDataChange}
                  getModuleRight={getModuleRight}
                />
              )
            }
          ],
          noDelete: true,
          data: role,
          title: 'Lignes',
          options: {
            pageSize: 4,
            search: false,
            paging: true,
            actionsColumnIndex: -1
          },
          actions: { add: false, edit: true, delete: false }
        },
        validation: [{ rule: 'req', error: 'Saisir au moins 1 ligne' }]
      }
    ]
  ]
}
